/**
 * Pilot System Banner Component
 * Non-intrusive banner for pilot/evaluation notice
 */

export function PilotBanner() {
  return (
    <div className="bg-[#F8FAFC] border-l-4 border-[#FACC15] px-4 py-3">
      <p className="text-[11px] text-[#475569] leading-relaxed">
        <span className="font-semibold">Pilot System</span> — Operational Records Platform
        <br />
        Used for evaluation and continuous improvement
      </p>
    </div>
  );
}
